/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible positions of the chart header.
 */
export const LINE_CHART_HEADER_POSITION = {
  center: 'center',
  left: 'left',
  right: 'right',
} as const;

/**
 * The config for the line chart series.
 */
export type LineChartSeriesConfig = {
  data: Array<number | null>;
  color?: string;
  seriesName?: string;
  lineWidth?: number;
  showMarkers?: boolean;
};

/**
 * Defines position of chart header content (heading/subheading).
 */
export type LineChartHeaderPosition = typeof LINE_CHART_HEADER_POSITION;

/**
 * The definition of the chart threshold.
 */
export interface Threshold {
  /**
   * The color code of the threshold line (e.g. 'red', '#00d1ff').
   */
  color?: string;

  /**
   * Show the threshold label.
   */
  showLabel?: boolean;

  /**
   * The style of the threshold line.
   */
  style?: Highcharts.DashStyleValue;

  /**
   * The threshold value.
   */
  value: number;
}
